import "./template";
import "./style";
/**
 * @typedef DialogOptions
 * @type {object}
 * @property {string} contentHtml
 */

export default class EmptyDialog {
  /**
   * 
   * @param {DialogOptions} options
   */
  constructor(options) {
    options = options || {};
    options.contentHtml = options.contentHtml || "";
    this.options = options;
  }
  /**
   * @param {DialogOptions} options 
   */


  show() {
    this.close();
    /**
     * @type {HTMLTemplateElement} template
     */

    const template = document.querySelector("#empty_dialog-template");
    const messageNode = document.importNode(template.content, true);
    messageNode.querySelector(".empty_dialog-app").setAttribute("data-empty_dialog-app", "true");
    const closeAction = this.close;
    messageNode.querySelector("[data-model='message']").insertAdjacentHTML('beforeend', this.options.contentHtml);
    const wrapper = messageNode.querySelector(".empty_dialog-app");
    wrapper.addEventListener("click", (value, ev) => {
      closeAction();
    });
    const outerElement = messageNode.querySelector("[data-model='outer']");
    outerElement.addEventListener("click", e => {
      e.stopPropagation();
    });
    document.body.appendChild(messageNode);

    if (!!this.options.onCreate) {
      this.options.onCreate();
    }
  }

  close() {
    let elements = document.querySelectorAll("[data-empty_dialog-app]");

    for (let x = 0; x < elements.length; x++) {
      let item = elements[x];
      item.parentNode.removeChild(item);
    }
  }

}